import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const WorkflowFlow = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 7C6.61941 7 7.56698 6.26428 7.88555 5.25H11C12.2426 5.25 13.25 6.25736 13.25 7.5C13.25 8.44951 12.6618 9.26165 11.83 9.59197C11.4666 8.66019 10.5604 8 9.5 8C8.38059 8 7.43302 8.73572 7.11445 9.75H5C2.92893 9.75 1.25 11.4289 1.25 13.5V14H2.75V13.5C2.75 12.2574 3.75736 11.25 5 11.25H7.11445C7.43302 12.2643 8.38059 13 9.5 13C10.6607 13 11.6366 12.2091 11.9182 11.1368C13.5454 10.7272 14.75 9.2543 14.75 7.5C14.75 5.42893 13.0711 3.75 11 3.75H7.88555C7.56698 2.73572 6.61941 2 5.5 2C4.38059 2 3.43302 2.73572 3.11445 3.75H1V5.25H3.11445C3.43302 6.26428 4.38059 7 5.5 7ZM5.5 5.5C6.05228 5.5 6.5 5.05228 6.5 4.5C6.5 3.94772 6.05228 3.5 5.5 3.5C4.94772 3.5 4.5 3.94772 4.5 4.5C4.5 5.05228 4.94772 5.5 5.5 5.5ZM10.5 10.5C10.5 11.0523 10.0523 11.5 9.5 11.5C8.94772 11.5 8.5 11.0523 8.5 10.5C8.5 9.94772 8.94772 9.5 9.5 9.5C10.0523 9.5 10.5 9.94772 10.5 10.5Z"
      fill="currentColor"
    />
  </Icon>
));

export default WorkflowFlow;
